<template>
    <div class="content-prizes container">
        <div class="content-prizes-header">
            <button tag="a" @click="hasHistory() 
                ? $router.go(-1) 
                : $router.push('/')" class="btn-return">
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="69" height="69" viewBox="0 0 69 69">
                    <defs>
                        <linearGradient id="linear-gradient" x1="0.5" x2="0.5" y2="1" gradientUnits="objectBoundingBox">
                        <stop offset="0" stop-color="#fece09"/>
                        <stop offset="1" stop-color="#f5891f"/>
                        </linearGradient>
                        <filter id="Ellipse_2" x="0" y="0" width="69" height="69" filterUnits="userSpaceOnUse">
                        <feOffset dy="6" input="SourceAlpha"/>
                        <feGaussianBlur stdDeviation="6" result="blur"/>
                        <feFlood flood-opacity="0.161"/>
                        <feComposite operator="in" in2="blur"/>
                        <feComposite in="SourceGraphic"/>
                        </filter>
                    </defs>
                    <g id="Group_2353" data-name="Group 2353" transform="translate(-18 -43)">
                        <g transform="matrix(1, 0, 0, 1, 18, 43)" filter="url(#Ellipse_2)">
                        <circle id="Ellipse_2-2" data-name="Ellipse 2" cx="16.5" cy="16.5" r="16.5" transform="translate(18 12)" fill="url(#linear-gradient)"/>
                        </g>
                        <path id="Union_1" data-name="Union 1" d="M11.562,0h.723V12.285h-.723V.723H0V0Z" transform="translate(55.187 79.873) rotate(-135)" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
                    </g>
                </svg>
                <h3>Prémios</h3>
            </button>
        </div>
        <div class="content-prizes-items">
            <div class="content-prizes-items-main"  >
                <!-- <div class="content-prizes-items-main-title">
                    <h3>faltam</h3>
                    <p >
                        <span>{{ tempoRestante.dias }}</span> dias
                        <span class="pl-2">{{ tempoRestante.horas }}</span> horas
                        <span>{{ tempoRestante.minutos }}</span> min
                    </p>
                </div> -->
                <div class="content-prizes-items-main-card" v-for="end, idx in end_prizes" :key="idx" @click="showModal(end)">
                    <div class="content-prizes-items-cards-card-item">
                        <div class="content-prizes-items-main-card-img" >
                            <img :src="end.prize_path" alt="prize">
                        </div>
                        <div class="content-prizes-items-main-card-text">
                            <h1>GRANDE SORTEIO</h1>
                            <h3>{{ end.name }}</h3>
                        </div>
                        <div class="content-prizes-items-main-card-btn">
                            <button @click="showModal(end)">saber mais</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="content-prizes-items-cards">
                <div class="content-prizes-items-cards-title">
                    <h3>Prémios imediatos</h3>
                </div>
                <div class="row">
                    <div class="col-md-6 content-prizes-items-cards-card" v-for="prize, i in other_prizes" :key="i" @click="showModal(prize)">
                        <div class="content-prizes-items-cards-card-item">
                            <div class="content-prizes-items-cards-card-item-img" >
                                <img :src="prize.prize_path" alt="prize">
                            </div>
                            <div class="content-prizes-items-cards-card-item-text">
                                <p>{{ prize.name }}</p>
                            </div>
                            <div class="content-prizes-items-cards-card-item-button">
                                <button @click="showModal(prize)">saber mais</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <PrizeDetail :prizes="prizedetail"/>
    </div>
</template>
<script>
import axios from 'axios'
import PrizeDetail from '../../components/modals/PrizeDetail.vue'

export default {
    name: 'Prizes',
    data() {
        return {
            prizes: {},
            end_at: null,
            currentDateTime: new Date(),
            end_prizes: {},
            other_prizes: {},
            prizedetail: {}
        }
    },
    components: {
        PrizeDetail
    },
    methods: {
        showModal(prize) {
            this.prizedetail = prize
            this.$bvModal.show('modal-prizedetail')
        },
        hasHistory() {
            return window.history.length > 1;
        },
        updateDateTime() {
            this.currentDateTime = new Date();
        }
    },
    computed: {
        tempoRestante() {
            let diferencaEmMilissegundos = new Date(this.end_at) - this.currentDateTime;

            let dias = Math.floor(diferencaEmMilissegundos / (1000 * 60 * 60 * 24));
            let horas = Math.floor((diferencaEmMilissegundos % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            let minutos = Math.floor((diferencaEmMilissegundos % (1000 * 60 * 60)) / (1000 * 60));

            return {
                dias: dias,
                horas: horas,
                minutos: minutos
            };
        }
    },
    async mounted() {
        axios.get("/api/v1/prizes")
            .then((resp) => {
                this.prizes = resp.data.prizes;
                this.end_at = resp.data.end_at;

                this.end_prizes = this.prizes.filter(prize => prize.is_end_prize === 1);
                this.other_prizes = this.prizes.filter(prize => prize.is_end_prize === 0);

            })

        setInterval(this.updateDateTime, 1000);
    },
}

</script>
<style lang="scss">
.content-prizes{
    margin-top: 210px;
    margin-bottom: 100px;
    &-header{
        width: 100%;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-direction: row;
        margin-left: -15px;
        button{
            all: unset;
            display: flex !important;;
            align-items: center!important;
            justify-content: center;
            h3{
                margin-bottom: 10px;
            }
        }
    }
    &-items{
        &-main{
            height: 178px;
            background-color: #FFF;
            border-radius: 30px;
            display: flex;
            justify-content: center;
            align-items: stretch;
            flex-direction: row;
            @media screen and (max-width: 992px) {
                height: auto;
                flex-direction: column;
                padding:0 35px;
            }
            &-title{
                max-width: 50%;
                font-size: 24px;
                font-family: 'Font Bold';
                width: 100%;
                text-align: left;
                margin: 15px 0;
                padding: 20px;
                border-right: 1px solid #FFCF00;
                @media screen and (max-width: 992px) {
                    max-width: 100%;
                    border-right: none;
                    border-bottom: 1px solid #FFCF00;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                }
                h3{
                    text-transform: uppercase;
                    margin-bottom: 30px;
                    color:#C3100D;
                }
                p{
                    font-size: 26px;
                    line-height: 35px;
                    span{
                        font-family: 'Font Bold';
                        font-size: 35px;
                    }
                }
            }
            &-card{
                height: 180px;
                width: 100%;
                position: relative;
                display: flex;
                justify-content: flex-end;
                margin-bottom: 30px;
                &-img{
                    position: absolute;
                    top:0px;
                    left: 0;
                    @media screen and (max-width: 992px) {
                        top: 15px;
                        left: 15px;
                        height: 141px;
                    }
                    img{
                        width: 225px;
                        height: auto;
                        @media screen and (max-width: 992px) {
                            width: 141px;
                            height: auto;
                        }
                    }
                }
                &-text{
                    text-align: right;
                    padding: 40px 20px;
                    display: flex;
                    justify-content: center;
                    flex-direction: column;
                    max-width: calc(100% - 200px);
                    @media screen and (max-width: 992px){
                        justify-content: flex-start;
                        align-items: flex-end;
                        padding: 20px;
                        height: 172px;
                        max-width: 100%;
                        width: 100%;
                        h4, p{
                            display: none;
                        }
                    }
                    h1{
                        font-size: 20px;
                        text-transform: uppercase;
                        color:#C3100D;
                    }
                        
                    h4{
                        font-size: 23px;
                        text-transform: uppercase;
                    }
                    h3{
                        text-transform: uppercase;
                        @media screen and (max-width: 992px) {
                            margin: 0;
                            font-size: 24px;
                            max-width: calc(100% - 141px);
                        }
                    }
                }
                &-btn{
                    position: absolute;
                    right: 35px;
                    bottom: -20px;
                    @media screen and (max-width: 992px) {
                        right: 20px;
                        bottom: -50px;
                    }
                    button{
                        width: 120px;
                        height: 40px;
                        border: none;
                        background: rgb(254,206,9);
                        background: linear-gradient(90deg, rgba(254,206,9,1) 0%, rgba(245,137,31,1) 100%);
                        color: black;
                        font-family: 'Font Bold';
                        font-size: 18px;
                        border-radius: 10px;
                    }
                }
            }
        }
        &-cards{
            margin-top: 50px;
            padding-top: 50px;
            width: 100%;
            @media screen and (max-width: 992px){
                padding-top: 0;
                
            }
            &-title{
                width: 100%;
                text-align: left;
                margin: 0 0 30px 0;
                border-bottom: 1px solid #FFCF00;
            }
            
            &-card{
                height: 180px;
                display: flex;
                justify-content: flex-end;
                align-items: center;
                position: relative;
                margin-bottom: 30px;
                @media screen and (max-width: 992px) {
                    height: auto;
                    max-width: 33%;
                    flex: 0 0 33%;
                }
                @media screen and (max-width: 767px) {
                    height: auto;
                    max-width: 50%;
                    flex: 0 0 50%;
                }
                &-item{
                    width: 100%;
                    display: flex;
                    justify-content: flex-end;
                    align-items: center;
                    position: relative;
                    border-radius: 10px;
                    padding: 20px;
                    background-color: #FFF;
                    @media screen and (max-width: 992px) {
                        padding: 0;
                        height: auto;
                        flex-direction: column;
                        justify-content: flex-end;
                        align-items: center;
                        width: 100%;
                    }
                    &-img{
                        position: absolute;
                        top: 0;
                        bottom: 0;
                        left: 0;
                        @media screen and (max-width: 992px) {
                           position: relative;
                        }
                        img{
                            width: auto;
                            height: 100%;
                            @media screen and (max-width: 992px) {
                                width: auto;
                                height: 91px;
                            }
                        }
                    }
                    &-text{
                        max-width: 132px;
                        text-align: right;
                        margin-right: 15px;
                        margin-top: 20px;
                        width: calc(100% - 132px);
                        @media screen and (max-width: 992px) {
                            width: 100%;
                            max-width: 100%;
                            margin-right: 0;
                            margin-top: 0;
                            text-align: center;
                            margin-top:15px;
                            margin-bottom: 35px;
                        }
                        p{
                            font-family: 'Font Regular';
                            font-size: 20px;
                            line-height: 28px;
                        }
                    }
                    &-button{
                        position: absolute;
                        right: 15px;
                        bottom: -20px;
                        button{
                            width: 120px;
                            height: 40px;
                            border: none;
                            background: rgb(254,206,9);
                            background: linear-gradient(90deg, rgba(254,206,9,1) 0%, rgba(245,137,31,1) 100%);
                            color: black;
                            font-family: 'Font Bold';
                            font-size: 18px;
                            border-radius: 10px;                      
                        }
                        @media screen and (max-width: 992px) {
                            right: 0;
                            left: 0;
                        }
                    }
                }
                
            }
        }
    }
}
</style>